/*
 * @author: liuxu7
 * @date: 2017-10-25
 * @description: 按钮组件
 * type: primary/ghost/dashed/text/info/success/warning/error
 * size: large/small/default
 * shape: circle
 * btnType: 原生button属性 + a
 * disabled: true/false
 * loading: true/false
 * */
import template from './index.html'
import ko from 'knockout'
import _ from '../../util/lodash'
import Base from '../../core/base'
import stringHash from 'string-hash'
const PREFIX = 'y-button-'
const FIELDIDAFFIX = '_btn'
class Button extends Base {
  initialize (params) {
    let innerTpl = params.label || (params.$templateNodes.length > 0 ? params.$templateNodes[0].textContent : '')
    this.fieldid = ''
    if (params.fieldid) {
      this.fieldid = params.fieldid + FIELDIDAFFIX
    } else if (innerTpl) {
      this.fieldid = stringHash(innerTpl) + FIELDIDAFFIX
    }
    // button
    let defaultFun = function () { }
    this.type = params.type ? (PREFIX + params.type) : ''
    this.size = params.size ? (PREFIX + params.size) : ''
    this.shape = params.shape ? (PREFIX + params.shape) : ''
    this.clickBubble = params.StopClickBubble ? !params.StopClickBubble : true
    this.long = params.long ? (PREFIX + 'long') : ''
    this.btnType = params.btnType || 'button'
    this.disabled = ko.isObservable(params.disabled) ? params.disabled : ko.observable(params.disabled || false)
    this.disabledCls = ko.computed(() => {
      if (typeof this.disabled === 'function') {
        return this.disabled() ? (PREFIX + 'disabled') : ''
      } else {
        return this.disabled ? (PREFIX + 'disabled') : ''
      }
    })
    this.classes = ko.computed(() => {
      return `${this.type} ${this.size} ${this.shape} ${this.long} ${this.disabledCls()}`
    })
    this.loading = params.loading || ko.observable(false)
    this.loadingText = params.loadingText || 'loading..'
    this.label = params.label || ''
    this.handleClick = params.click || defaultFun
    this.handleReClick = _.debounce((data, event) => {
      // 如果正在loading中则不允许再次点击
      if (!this.loading()) {
        this.handleClick(data, event)
        this.disabled(true)
        setTimeout(() => {
          this.disabled(false)
        }, params.wait || 0)
      }
    }, params.wait || 0, {
      'leading': true
    })

    // a target
    this.url = params.url || 'javascript:;'
    if (params.rootPath) {
      this.url = 'http://' + this.url
    }
    this.target = params.target || '_self'
  }
}
export default {
  name: 'button',
  init: Base.createViewModel(Button),
  template
}



// WEBPACK FOOTER //
// ./src/components/button/index.js